import { Tooltip } from "@octopusdeploy/design-system-components";
import type { KubernetesLiveResourceSyncStatusCode } from "@octopusdeploy/octopus-server-client";
import type { LiveStatusIconSize } from "./LiveAppIcons";
import * as LiveAppStatusIcon from "./LiveAppIcons";
interface SyncStatusIconProps {
    status: KubernetesLiveResourceSyncStatusCode;
    size: LiveStatusIconSize;
}
export const SyncStatusIcon = ({ status, size }: SyncStatusIconProps) => {
    if (status === "NotApplicable") {
        return <></>;
    }
    switch (status) {
        case "OutOfSync":
            return <Tooltip content={"Desired state on the cluster is different from the desired state applied"}>{LiveAppStatusIcon.OutOfSyncIcon(size)}</Tooltip>;
        case "GitDrift":
            return <Tooltip content={"The application configuration in Git does not match what Octopus last applied"}>{LiveAppStatusIcon.GitDriftIcon(size)}</Tooltip>;
        case "InSync":
            return <Tooltip content={"Matches desired state"}>{LiveAppStatusIcon.InSyncIcon(size)}</Tooltip>;
        case "Unavailable":
            return <Tooltip content={"Application live status is unavailable because your last deployment failed"}>{LiveAppStatusIcon.UnavailableIcon(size)}</Tooltip>;
        case "Waiting":
            return <Tooltip content={"A deployment is in progress"}>{LiveAppStatusIcon.WaitingIcon(size)}</Tooltip>;
        default:
            return <Tooltip content={"The sync status of the application is unknown"}>{LiveAppStatusIcon.UnknownIcon(size)}</Tooltip>;
    }
};
